import { useNavigate } from 'react-router-dom';

import { ApplicationTile, listGeneralApplications } from '@shared/ui';

import './PortalLeftSideBar.css';
import { Box, Stack, Typography } from '@mui/material';
import { useAuthorizationContext } from 'hpacademy-data-authentication';
import { IUser } from '@shared/types';

const Information = ({ user }: { user: IUser }) => {
  return (
    <Box className='user-info'>
      <Box className='user-details'>
        <span>Welcome, </span>
        <h3 className='username'>{user.name}</h3>
        {user.username && <Typography className='email'>@{user.username}</Typography>}
      </Box>
    </Box>
  );
};

export const PortalLeftSidebar = () => {
  const {
    state: { user },
  } = useAuthorizationContext();
  const navigate = useNavigate();
  const role = user?.userInfo?.role;
  const activeAppsByRole = role ? listGeneralApplications(role) : [];

  const onNavigate = (url: string) => {
    navigate(url);
  };

  if (!user?.userInfo) {
    return null;
  }

  return (
    <Box className='left-section' sx={{
      width: {
        xs: "300px",
        md: "360px",
      },
    }}>
      <Stack className='left-content' justifyContent={'center'} >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={'/images/logo.png'} style={{ width: '250px' }} />
        </Box>

        <Stack>
          <Information user={user.userInfo} />

          <hr></hr>
          <div className='applications'>
            <Stack flexDirection={'row'} flexWrap={'wrap'} gap={0} width={'100%'}>
              {activeAppsByRole.map(app => (
                <ApplicationTile onNavigate={onNavigate} key={app.id} application={app} isActive={false} />
              ))}
            </Stack>
          </div>
        </Stack>

      </Stack>
    </Box>
  );
};
